import { Injectable, ɵɵdefineInjectable, Component, Input, ViewChild, NgModule } from '@angular/core';
import { TooltipDirective, TooltipModule } from '@progress/kendo-angular-tooltip';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AaclIconModule } from 'aacl-icon';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-keyword-search.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@progress/kendo-angular-tooltip';
import * as ɵngcc4 from 'aacl-icon';

const _c0 = ["keywordInput"];
function AaclKeywordSearchComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵlistener("click", function AaclKeywordSearchComponent_div_7_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.clear()); });
    ɵngcc0.ɵɵelement(1, "aacl-icon", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("name", "close");
} }
class AaclKeywordSearchService {
    constructor() { }
}
AaclKeywordSearchService.ɵfac = function AaclKeywordSearchService_Factory(t) { return new (t || AaclKeywordSearchService)(); };
/** @nocollapse */
AaclKeywordSearchService.ctorParameters = () => [];
/** @nocollapse */ AaclKeywordSearchService.ɵprov = ɵɵdefineInjectable({ factory: function AaclKeywordSearchService_Factory() { return new AaclKeywordSearchService(); }, token: AaclKeywordSearchService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclKeywordSearchService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-keyword-search.options.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const EnumAaclKeywordSearchFeedbackTypes = {
    CHANGE: "CHANGE",
};
/** @enum {string} */
const EnumAaclKeywordSearchActionTypes = {
    CLEAR: "CLEAR",
    SET: "SET",
};
class AaclKeywordSearchAction {
}
if (false) {
    /** @type {?} */
    AaclKeywordSearchAction.prototype.type;
    /** @type {?} */
    AaclKeywordSearchAction.prototype.payload;
}
class AaclKeywordSearchFeedback {
}
if (false) {
    /** @type {?} */
    AaclKeywordSearchFeedback.prototype.type;
    /** @type {?} */
    AaclKeywordSearchFeedback.prototype.payload;
}
class AaclKeywordSearchOptions {
    /**
     * @param {?=} keyword
     * @param {?=} timeout
     * @param {?=} placeholder
     */
    constructor(keyword, timeout, placeholder) {
        this.actionSubject$ = new Subject();
        this.feedbackSubject$ = new Subject();
        if (keyword !== null && keyword !== undefined) {
            this.keyword = keyword;
        }
        this.timeout = timeout ? timeout : 250;
        this.triggerOnEnter = false;
        this.placeholder = placeholder ? placeholder : 'Search';
        this.style = {};
    }
}
if (false) {
    /** @type {?} */
    AaclKeywordSearchOptions.prototype.actionSubject$;
    /** @type {?} */
    AaclKeywordSearchOptions.prototype.feedbackSubject$;
    /** @type {?} */
    AaclKeywordSearchOptions.prototype.keyword;
    /** @type {?} */
    AaclKeywordSearchOptions.prototype.timeout;
    /** @type {?} */
    AaclKeywordSearchOptions.prototype.triggerOnEnter;
    /** @type {?} */
    AaclKeywordSearchOptions.prototype.placeholder;
    /** @type {?} */
    AaclKeywordSearchOptions.prototype.style;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-keyword-search.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AaclKeywordSearchComponent {
    constructor() {
        this._destroySubscriptions = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.options.actionSubject$) {
            this._destroySubscriptions.push(this.options.actionSubject$.subscribe((/**
             * @param {?} action
             * @return {?}
             */
            action => this._onSubscribeActions(action))));
        }
        this.keyword = this.options.keyword ? this.options.keyword : '';
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._destroySubscriptions.forEach((/**
         * @param {?} subscription
         * @return {?}
         */
        subscription => subscription.unsubscribe()));
        this._destroySubscriptions = [];
    }
    /**
     * @return {?}
     */
    clear() {
        this.keyword = '';
        if (this.options.feedbackSubject$) {
            this.options.feedbackSubject$.next({
                type: EnumAaclKeywordSearchFeedbackTypes.CHANGE,
                payload: {
                    data: '',
                    state: this.keyword
                }
            });
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyup(event) {
        if (event.keyCode === 13) {
            if (this.keyword === '' && this.options.feedbackSubject$) {
                // input nothing and press ENTER will trigger list refresh
                this.options.feedbackSubject$.next({
                    type: EnumAaclKeywordSearchFeedbackTypes.CHANGE,
                    payload: {
                        data: '',
                        state: this.keyword
                    }
                });
                return;
            }
            if (this.options.triggerOnEnter && this.options.feedbackSubject$) {
                this.options.feedbackSubject$.next({
                    type: EnumAaclKeywordSearchFeedbackTypes.CHANGE,
                    payload: {
                        data: this._escapeSearchString(this.keyword),
                        state: this.keyword
                    }
                });
                return;
            }
        }
        if (!this.options.triggerOnEnter) {
            this.keyword = this.keyword;
            setTimeout((/**
             * @return {?}
             */
            () => {
                if (this.options.feedbackSubject$) {
                    this.options.feedbackSubject$.next({
                        type: EnumAaclKeywordSearchFeedbackTypes.CHANGE,
                        payload: {
                            data: this._escapeSearchString(this.keyword.trim()),
                            state: this.keyword
                        }
                    });
                }
            }), this.options.timeout ? this.options.timeout : 250);
        }
    }
    /**
     * @return {?}
     */
    showClearButton() {
        if (this.keyword) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * @private
     * @param {?} action
     * @return {?}
     */
    _onSubscribeActions(action) {
        if (action.type === EnumAaclKeywordSearchActionTypes.CLEAR) {
            this.keyword = '';
        }
        else if (action.type === EnumAaclKeywordSearchActionTypes.SET) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.keyword = action.payload;
            }));
        }
    }
    /**
     * @private
     * @param {?} searchText
     * @return {?}
     */
    _escapeSearchString(searchText) {
        if (searchText.startsWith('"') && searchText.endsWith('"')) {
            return '"' + this._escapeLuceneSpecialCharacters(searchText.slice(1, -1)) + '"';
        }
        else {
            return this._escapeLuceneSpecialCharacters(searchText);
        }
    }
    /**
     * @private
     * @param {?} searchText
     * @return {?}
     */
    _escapeLuceneSpecialCharacters(searchText) {
        /** @type {?} */
        let escapeString = searchText;
        /** @type {?} */
        const specialSingleChars = ['\\', '+', '-', '!', '(', ')', '{', '}', '[', ']', '^', '"', '~', '*', '?', ':', '&', '|'];
        specialSingleChars.forEach((/**
         * @param {?} character
         * @return {?}
         */
        character => {
            escapeString = escapeString.replace(character, '\\' + character);
        }));
        return escapeString;
    }
}
AaclKeywordSearchComponent.ɵfac = function AaclKeywordSearchComponent_Factory(t) { return new (t || AaclKeywordSearchComponent)(); };
AaclKeywordSearchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AaclKeywordSearchComponent, selectors: [["aacl-keyword-search"]], viewQuery: function AaclKeywordSearchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TooltipDirective, 5);
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tooltipDir = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.keywordInputEle = _t.first);
    } }, inputs: { options: "options" }, decls: 8, vars: 5, consts: [[1, "aacl-keyword-search-container", 3, "ngStyle"], [1, "icon-area"], [3, "name"], ["kendoTooltip", "", "showOn", "none", "position", "bottom", 1, "input-area"], ["tooltip", ""], ["tid", "keywordSearch", "type", "text", "autocomplete", "off", "autocorrect", "off", "autocapitalize", "off", "spellcheck", "false", "title", "Minimum 3 characters to start keyword search", 3, "placeholder", "ngModel", "ngModelChange", "keyup"], ["keywordInput", ""], ["tid", "clearKeyword", "class", "clear-text-button", 3, "click", 4, "ngIf"], ["tid", "clearKeyword", 1, "clear-text-button", 3, "click"]], template: function AaclKeywordSearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "aacl-icon", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3, 4)(5, "input", 5, 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function AaclKeywordSearchComponent_Template_input_ngModelChange_5_listener($event) { return ctx.keyword = $event; })("keyup", function AaclKeywordSearchComponent_Template_input_keyup_5_listener($event) { return ctx.onKeyup($event); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(7, AaclKeywordSearchComponent_div_7_Template, 2, 1, "div", 7);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ctx.options.style);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("name", "search");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.options.placeholder);
        ɵngcc0.ɵɵproperty("ngModel", ctx.keyword);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClearButton());
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgStyle, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc3.TooltipDirective, ɵngcc4.AaclIconComponent], styles: [".aacl-keyword-search-container[_ngcontent-%COMP%], [_nghost-%COMP%]{display:flex;height:100%;width:100%}.aacl-keyword-search-container[_ngcontent-%COMP%]{align-items:center;background-color:#fff;border:1px solid #d3d3d3;border-radius:2px}.aacl-keyword-search-container[_ngcontent-%COMP%]:focus-within{border:1px solid #06bee1;border-radius:2px}.aacl-keyword-search-container[_ngcontent-%COMP%]   .icon-area[_ngcontent-%COMP%]{color:rgba(0,0,0,.65);flex-shrink:-1;padding:0 8px}.aacl-keyword-search-container[_ngcontent-%COMP%]   .input-area[_ngcontent-%COMP%]{flex-grow:1;height:100%}.aacl-keyword-search-container[_ngcontent-%COMP%]   .input-area[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:none;box-sizing:border-box;display:block;font-size:14px;height:100%;width:95%}.aacl-keyword-search-container[_ngcontent-%COMP%]   .input-area[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{outline:none}.aacl-keyword-search-container[_ngcontent-%COMP%]   .clear-text-button[_ngcontent-%COMP%]{color:rgba(0,0,0,.65);cursor:pointer;flex-shrink:-1;font-size:12px;padding:0 4px}"] });
/** @nocollapse */
AaclKeywordSearchComponent.ctorParameters = () => [];
AaclKeywordSearchComponent.propDecorators = {
    options: [{ type: Input }],
    tooltipDir: [{ type: ViewChild, args: [TooltipDirective,] }],
    keywordInputEle: [{ type: ViewChild, args: ['keywordInput',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclKeywordSearchComponent, [{
        type: Component,
        args: [{ selector: 'aacl-keyword-search', template: "<div class=\"aacl-keyword-search-container\" [ngStyle]=\"options.style\">\r\n    <div class=\"icon-area\">\r\n        <aacl-icon [name]=\"'search'\"></aacl-icon>\r\n    </div>\r\n    <div class=\"input-area\" kendoTooltip #tooltip showOn=\"none\" position=\"bottom\">\r\n        <input placeholder=\"{{ options.placeholder }}\" tid=\"keywordSearch\" #keywordInput type=\"text\" [(ngModel)]=\"keyword\" (keyup)=\"onKeyup($event)\"\r\n            autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\"\r\n            title=\"Minimum 3 characters to start keyword search\">\r\n    </div>\r\n    <div tid=\"clearKeyword\" class=\"clear-text-button\" (click)=\"clear()\" *ngIf=\"showClearButton()\">\r\n        <aacl-icon [name]=\"'close'\"></aacl-icon>\r\n    </div>\r\n</div>", styles: [".aacl-keyword-search-container,:host{display:flex;height:100%;width:100%}.aacl-keyword-search-container{align-items:center;background-color:#fff;border:1px solid #d3d3d3;border-radius:2px}.aacl-keyword-search-container:focus-within{border:1px solid #06bee1;border-radius:2px}.aacl-keyword-search-container .icon-area{color:rgba(0,0,0,.65);flex-shrink:-1;padding:0 8px}.aacl-keyword-search-container .input-area{flex-grow:1;height:100%}.aacl-keyword-search-container .input-area input{border:none;box-sizing:border-box;display:block;font-size:14px;height:100%;width:95%}.aacl-keyword-search-container .input-area input:focus{outline:none}.aacl-keyword-search-container .clear-text-button{color:rgba(0,0,0,.65);cursor:pointer;flex-shrink:-1;font-size:12px;padding:0 4px}"] }]
    }], function () { return []; }, { options: [{
            type: Input
        }], tooltipDir: [{
            type: ViewChild,
            args: [TooltipDirective]
        }], keywordInputEle: [{
            type: ViewChild,
            args: ['keywordInput']
        }] }); })();
if (false) {
    /** @type {?} */
    AaclKeywordSearchComponent.prototype.options;
    /** @type {?} */
    AaclKeywordSearchComponent.prototype.tooltipDir;
    /** @type {?} */
    AaclKeywordSearchComponent.prototype.keywordInputEle;
    /** @type {?} */
    AaclKeywordSearchComponent.prototype.keyword;
    /**
     * @type {?}
     * @private
     */
    AaclKeywordSearchComponent.prototype._destroySubscriptions;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-keyword-search.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AaclKeywordSearchModule {
}
AaclKeywordSearchModule.ɵfac = function AaclKeywordSearchModule_Factory(t) { return new (t || AaclKeywordSearchModule)(); };
AaclKeywordSearchModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AaclKeywordSearchModule });
AaclKeywordSearchModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        TooltipModule,
        AaclIconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclKeywordSearchModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AaclKeywordSearchComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    TooltipModule,
                    AaclIconModule
                ],
                exports: [
                    AaclKeywordSearchComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AaclKeywordSearchModule, { declarations: function () { return [AaclKeywordSearchComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        TooltipModule,
        AaclIconModule]; }, exports: function () { return [AaclKeywordSearchComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: aacl-keyword-search.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AaclKeywordSearchAction, AaclKeywordSearchComponent, AaclKeywordSearchFeedback, AaclKeywordSearchModule, AaclKeywordSearchOptions, AaclKeywordSearchService, EnumAaclKeywordSearchActionTypes, EnumAaclKeywordSearchFeedbackTypes };

